import Vue from 'vue'
import Router from 'vue-router'

import Login from '../components/Login.vue'
import Switch from '../components/Switch.vue'
import Dashboard from '../modules/dashboard/Dashboard.vue'

import Crm from '../modules/crm/Index.vue'
import CrmDashboard from '../modules/crm/Dashboard.vue'

import CheckinHome from '../modules/checkin/Index.vue'

import Checkin from '../modules/checkin/reservation/Index.vue'
import CheckinEdit from '../modules/checkin/reservation/Edit.vue'

import Config from '../modules/config/Index.vue'
import ConfigDashboard from '../modules/config/Dashboard.vue'

import ConfigAttribute from '../modules/config/attribute/Index.vue'
import ConfigAttributeEdit from '../modules/config/attribute/Edit.vue'
import ConfigAttributeImport from '../modules/config/attribute/Import.vue'

import ConfigTransporter from '../modules/config/transporter/Index.vue'
import ConfigTransporterEdit from '../modules/config/transporter/Edit.vue'

import ConfigRating from '../modules/config/rating/Index.vue'
import ConfigRatingEdit from '../modules/config/rating/Edit.vue'

import Person from '../modules/person/Index.vue'
import PersonEdit from '../modules/person/Edit.vue'
//import PersonCreate from '../modules/person/Create.vue'

import Company from '../modules/company/Index.vue'
import CompanyEdit from '../modules/company/Edit.vue'
//import CompanyCreate from '../modules/company/Create.vue'

import Scope from '../modules/scope/Index.vue'
import ScopeEdit from '../modules/scope/Edit.vue'

import Media from '../modules/media/Index.vue'
import MediaImport from '../modules/media/Import.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/switch',
            name: 'Switch',
            component: Switch,
            meta: {
                clientIsOptional: true,
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            }
        },
        {
            path: '/media',
            name: 'media',
            component: Media,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'import',
                    name: 'media-import',
                    component: MediaImport,
                    meta: {
                        action: "import",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                }
            ]
        },
        {
            path: '/crm',
            name: 'crm',
            component: Crm,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'crm-dashboard',
                    component: CrmDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'person',
                    name: 'person',
                    component: Person,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'person-new',
                            component: PersonEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'person-edit',
                            component: PersonEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                },
                {
                    path: 'company',
                    name: 'company',
                    component: Company,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'company-new',
                            component: CompanyEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'company-edit',
                            component: CompanyEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: '/checkin',
            name: 'checkin',
            component: CheckinHome,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: 'reservation',
                    name: 'reservation',
                    component: Checkin,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'reservation-new',
                            component: CheckinEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'reservation-edit',
                            component: CheckinEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: '/config',
            name: 'config',
            component: Config,
            meta: {
                action: "index",
                authenticated: true,
                permissions: {
                    roles: ['user']
                }
            },
            children: [
                {
                    path: '',
                    name: 'config-dashboard',
                    component: ConfigDashboard,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    }
                },
                {
                    path: 'attribute',
                    name: 'attribute',
                    component: ConfigAttribute,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'attribute-new',
                            component: ConfigAttributeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: 'import',
                            name: 'attribute-import',
                            component: ConfigAttributeImport,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'attribute-edit',
                            component: ConfigAttributeEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'scope',
                    name: 'scope',
                    component: Scope,
                    meta: {
                        action: "index",
                        authenticated: true,
                        permissions: {
                            roles: ['user']
                        }
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'scope-new',
                            component: ScopeEdit,
                            meta: {
                                action: "new",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        },
                        {
                            path: ':id',
                            name: 'scope-edit',
                            component: ScopeEdit,
                            meta: {
                                action: "edit",
                                authenticated: true,
                                permissions: {
                                    roles: ['user']
                                }
                            }
                        }

                    ]
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js